/**
 * Simple handing of getting keys from the translation objects.
 * They get loaded separately, cause we use site settings to know
 * what js file to use.
 */

/**
 * @prop {Object} translations Keys for translation.
 */
let translations = {};

/**
 * Set the translation object to use.
 * @param {Object} data Keys and strings
 */
const setTranslationData = function(data) {
    translations = data;
};

/**
 * Find the translation for the id.
 * Handles multilevel objects via prop.prop.prop type ids.
 * @param {String} textId Text code
 * @returns {String}
 */
const getTranslation = function(textId) {
    const textParts = textId.split('.');
    if (textParts.length === 1) {
        return translations[textParts[0]] || '';
    }
    let langObject = translations[textParts[0]];
    if (typeof langObject !== 'object') {
        return '';
    }
    for (let i = 1; i < textParts.length; i++) {
        if (i === textParts.length - 1) {
            // last part.
            return langObject[textParts[i]] || '';
        }
        langObject = langObject[textParts[i]];
        if (typeof langObject !== 'object') {
            return '';
        }
    }
    return '';
};

/**
 * Get the translation if possible.
 * @param {String} key Language key (usually "foo.bar")
 * @param {String} defaultText Default text.
 * @param {Object} vars Keys to replace in text (in the translation they are wrapped in "%varname%").
 * @returns {String}
 */
const localize = function(key, defaultText, vars = {}) {
    let returnText = getTranslation(key);
    if (returnText === '') {
        returnText = defaultText;
    }
    const varKeys = Object.keys(vars);
    if (varKeys.length === 0) {
        return returnText;
    }
    varKeys.forEach((k) => {
        returnText = returnText.replace(`%${k}%`, vars[k]);
    });
    return returnText;
};

export {
    setTranslationData,
    localize
};
